import { SnackbarHost } from "~/shared_states/snackbar";

export default function ClientOnlySnackbarHost() {
  return <SnackbarHost />;
}
